import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { downloadFile } from "lib/utils";
import { useGetBidDocumentUrl } from "./useGetBidDocumentUrl";

export type BasicDocumentDetails = {
  documentId: string;
  fileName: string;
};

export function useDownloadBidDocument(
  options?: UseMutationOptions<void, unknown, BasicDocumentDetails, unknown>,
) {
  const { mutateAsync: getBidDocumentUrlMutation } = useGetBidDocumentUrl();

  const mutation = useMutation<void, AxiosError, BasicDocumentDetails>(
    async ({ documentId, fileName }) => {
      // Fetch the document URL
      const { getBidDocumentUrl } = await getBidDocumentUrlMutation({ id: documentId });
      const documentUrl = getBidDocumentUrl.documentUrl;

      if (!documentUrl) throw new Error("Failed to retrieve document URL.");

      // Fetch the actual file
      const response = await fetch(documentUrl);
      if (!response.ok) throw new Error("Failed to download document.");

      // Convert response to Blob
      const blob = await response.blob();

      // Download the file
      downloadFile(blob, fileName);
    },
    options,
  );

  return { ...mutation };
}
